"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PromptVariable = void 0;
var create_entity_1 = require("../../utils/create-entity");
exports.PromptVariable = {
  name: 'PromptVariable',
  type: 'taxonomy',
  table: {
    fieldNames: ["info", "label", "controlType", "useVectorStore"]
  },
  list: {
    resultsVariant: "list"
  },
  form: {
    modal: {
      maxWidth: "900px"
    },
    fieldSets: [{
      name: 'overview'
    }, {
      name: 'form-field',
      label: 'Form Field',
      intro: "These settings will be used when the GPT interface is used in a GLOBAL top-level scenario, where there is no logical 'current' entity to generate content about."
    }, {
      name: 'form-field-contextual',
      label: 'Form Field (Contextual)',
      intro: "These settings will be used when the GPT interface is used in a CONTEXTUAL (non-global) scenario, where you want the user to generate content about a 'current' page entity (on a details page for an entity, for example)."
    }],
    fields: __assign(__assign({}, create_entity_1.entityStandardFormFields), {
      description: {
        type: 'longText'
      },
      useVectorStore: {
        type: 'boolean',
        recommended: false,
        description: 'Should queries made on this variable search the vector database store? The vector database store represents data which has been curated for this particular platform, rather than the wider World Wide Web as a whole, which should lead to more accurate and sourceable results.'
      },
      controlType: {
        type: 'linked',
        fieldSet: 'form-field',
        entityTypeName: 'ControlType',
        recommended: false,
        description: 'What type of UI control should be created for this {{VARIABLE}} when prompting for it in a chat interface. Note: if not specified, the variable will likely be derived from the current context of the page hosting the interface.'
      },
      entityTypes: {
        type: 'linkedMultiple',
        fieldSet: 'form-field',
        entityTypeName: 'EntityType',
        recommended: false,
        description: 'What type(s) of entity does this variable represent, if any? This will give the query engine more information about how to query for the variable, and may also affect the user interface, for example a select box would present selections with options which are these entity types.'
      },
      label: {
        type: 'text',
        fieldSet: 'form-field',
        description: 'What label should be used for this {{PROMPT_VARIABLE}} when showing the field in a user interface? For example, this label would be shown in a placeholder for a textarea or select box.'
      },
      labelAnother: {
        type: 'text',
        label: 'Label (Another)',
        fieldSet: 'form-field',
        description: "Specify a different label to use when this {{PROMPT_VARIABLE}} is a follow-on query. E.g., you might want the standard label above to be 'Ask a question', but use 'Ask another question' when the conversation is already in progress."
      },
      help: {
        type: 'textArea',
        fieldSet: 'form-field',
        description: 'Provide help text for this {{PROMPT_VARIABLE}} , to show as a popup or tooltip when the user hovers over an info icon next to the form field or the field itself.'
      },
      defaultValue: {
        type: 'text',
        fieldSet: 'form-field',
        description: 'What default value should be used for this {{PROMPT_VARIABLE}}? Note: this is only applicable to text or standard select fields'
      },
      options: {
        type: 'textArea',
        fieldSet: 'form-field',
        description: "Specify a series of line-separated options for any select controls. Note: this is only applicable for standard (non-entity) SELECT fields, entity select fields are populated with collections of data based on the entity types selected."
      },
      controlTypeContextual: {
        type: 'linked',
        label: 'Control Type (Contextual)',
        fieldSet: 'form-field-contextual',
        entityTypeName: 'ControlType',
        recommended: false,
        description: 'What type of UI control should be created for this {{VARIABLE}} when prompting for it in a chat interface. Note: if not specified, the variable will likely be derived from the current context of the page hosting the interface.'
      },
      entityTypesContextual: {
        type: 'linkedMultiple',
        label: 'Entity Types (Contextual)',
        fieldSet: 'form-field-contextual',
        entityTypeName: 'EntityType',
        recommended: false,
        description: 'What type(s) of entity does this variable represent, if any? This will give the query engine more information about how to query for the variable, and may also affect the user interface, for example a select box would present selections with options which are these entity types.'
      },
      labelContextual: {
        type: 'text',
        label: 'Label (Contextual)',
        fieldSet: 'form-field-contextual',
        description: 'What label should be used for this {{PROMPT_VARIABLE}} when showing the field in a user interface? For example, this label would be shown in a placeholder for a textarea or select box.'
      },
      labelAnotherContextual: {
        type: 'text',
        label: 'Label (Another) (Contextual)',
        fieldSet: 'form-field-contextual',
        description: "Specify a different label to use when this {{PROMPT_VARIABLE}} is a follow-on query. E.g., you might want the standard label above to be 'Ask a question', but use 'Ask another question' when the conversation is already in progress."
      },
      helpContextual: {
        type: 'textArea',
        label: 'Help (Contextual)',
        fieldSet: 'form-field-contextual',
        description: 'Provide help text for this {{PROMPT_VARIABLE}} , to show as a popup or tooltip when the user hovers over an info icon next to the form field or the field itself.'
      },
      defaultValueContextual: {
        type: 'text',
        label: 'Default Value (Contextual)',
        fieldSet: 'form-field-contextual',
        description: 'What default value should be used for this {{PROMPT_VARIABLE}}? Note: this is only applicable to text or standard select fields'
      },
      optionsContextual: {
        type: 'textArea',
        label: 'Options (Contextual)',
        fieldSet: 'form-field-contextual',
        description: "Specify a series of line-separated options for any select controls. Note: this is only applicable for standard (non-entity) SELECT fields, entity select fields are populated with collections of data based on the entity types selected."
      }
    })
  },
  autoRoutes: ['list', 'create', 'update']
};